import { gql } from "@apollo/client";

export const ACTIVE_OFFICERS_QUERY = gql`
  query ACTIVE_OFFICERS_QUERY($oriIds: String!, $originatorId: ID!) {
    activeOfficers(oriIds: $oriIds, originatorId: $originatorId) {
      id
      deptAttribute {
        id
        badge
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
          municipalityNumber
        }
        team {
          id
          name
        }
      }
      personalAttribute {
        id
        firstName
        lastName
      }
    }
  }
`;
